import { SMSLogsList } from "./SMSLogsList";

export default {
	list: SMSLogsList,
};
